<div class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">
      {{ "GUI.Patient History.PrintHistory.Print History" | translate }}
    </h2>
    <button (click)="close()" class="print-history-popup-close" aria-label="close popup"></button>

    <img *ngIf="loadingPrint" src="../../assets/images/Wedges.svg" class="pdf-loader" />

    <div class="print-table-scroll" *ngIf="!loadingPrint && previousReports.length">
      <table mat-table [dataSource]="previousReports" class="mat-elevation-z8 print-table">
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element">
            {{ previousReports.indexOf(element) + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>
            {{ "GUI.Patient History.PrintHistory.Date" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.creationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>
            {{ "GUI.Patient History.PrintHistory.Hour" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.creationTime }}
          </td>
        </ng-container>

        <ng-container matColumnDef="physician">
          <th mat-header-cell *matHeaderCellDef>
            {{ "GUI.Patient History.Done by" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.opener }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          (click)="openReport(row)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>

    <p class="print-history-message" *ngIf="!loadingPrint && !previousReports.length && !hasError">
      {{ "GUI.Patients.empty.reports" | translate }}
    </p>
    <p class="print-history-message" *ngIf="!loadingPrint && hasError">
      {{ "GUI.errorMessages.Error" | translate }}
    </p>
  </div>
</div>
